module.exports = __webpack_public_path__ + "img/SketchPngf7b27f655bc087d7936db0f4a02fcfb45c5034e522d336f01b41a3336bb9b432.361dedc4.png";